import { useState } from 'react';
import { useQuery } from 'react-query';
import { ordenService, Orden } from '../../services/ordenService';

interface RecuperarOrdenModalProps {
  sesionCajaId: number;
  onClose: () => void;
  onSeleccionarOrden: (orden: Orden) => void;
}

const RecuperarOrdenModal = ({ sesionCajaId, onClose, onSeleccionarOrden }: RecuperarOrdenModalProps) => {
  const [search, setSearch] = useState('');

  const { data, isLoading } = useQuery(
    ['ordenes-pendientes', sesionCajaId],
    () => ordenService.getAll(1, 50, sesionCajaId, 'pendiente'),
    { enabled: !!sesionCajaId }
  );

  const ordenes = data?.data.ordenes || [];
  const ordenesFiltradas = ordenes.filter((orden) => {
    if (!search) return true;
    const searchLower = search.toLowerCase();
    return (
      orden.numeroOrden?.toLowerCase().includes(searchLower) ||
      orden.id.toString().includes(search) ||
      orden.cliente?.nombre?.toLowerCase().includes(searchLower)
    );
  });

  const handleSeleccionar = async (orden: Orden) => {
    // Cargar la orden completa con todas sus líneas
    try {
      const ordenCompleta = await ordenService.getById(orden.id);
      onSeleccionarOrden(ordenCompleta.data.orden);
      onClose();
    } catch (error) {
      console.error('Error cargando orden completa:', error);
      // Si falla, usar la orden del listado
      onSeleccionarOrden(orden);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Recuperar Orden Pendiente</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ×
          </button>
        </div>

        <div className="mb-4">
          <input
            type="text"
            placeholder="Buscar por número de orden, ID o cliente..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>

        {isLoading ? (
          <div className="text-center py-8">Cargando...</div>
        ) : ordenesFiltradas.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            No hay órdenes pendientes
          </div>
        ) : (
          <div className="space-y-2">
            {ordenesFiltradas.map((orden) => (
              <div
                key={orden.id}
                onClick={() => handleSeleccionar(orden)}
                className="p-4 border rounded hover:bg-gray-50 cursor-pointer transition"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <div className="font-medium">
                      {orden.numeroOrden || `Orden #${orden.id}`}
                    </div>
                    <div className="text-sm text-gray-500">
                      Cliente: {orden.cliente?.nombre || 'Cliente General'}
                    </div>
                    <div className="text-sm text-gray-500">
                      {orden.lineas?.length || 0} productos
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-bold text-lg">
                      ${(Number(orden.total) || 0).toFixed(2)}
                    </div>
                    <div className="text-xs text-gray-500">
                      {orden.createdAt ? new Date(orden.createdAt).toLocaleString() : ''}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecuperarOrdenModal;

